import { PlayerProfileFragment } from 'generated/spin-graphql';
import React from 'react';
import { PlayerProfile } from './PlayerProfile';
import { ProfileBannerMessage } from './profile-page/ProfileBannerMessage';

export function ExampleProfile({ player }: { player: PlayerProfileFragment }) {
    const exampleMessage = `This is what a player profile looks like for any player that has an account on the website.
    However, only subscribing colleges can see this in an effort to ensure only those who need to
    see the player's information can see it.`;

    return (
        <div className="container example-player-profile-container">
            <ProfileBannerMessage
                title="Example Player Profile"
                copy={exampleMessage}
                cta={{
                    ctaLabel: 'Upgrade',
                    ctaLink: '/dashboard/subscriptions',
                }}
            />
            <div className="player-profile-container">
                <PlayerProfile player={player} examplePlayer={true} />
            </div>
        </div>
    );
}
